<template>
  <div v-show="isLoading" class="overlay" ></div>
</template>

<script>

 export default {
   name: 'overlay',
   props: ['isLoading']
}
</script>

<style lang="scss">
  .overlay{
      top:0;
      width: 100%;
      height: 100%;
      background: black;
      opacity: .3;
      position: absolute;
      z-index: 10;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/sidebar/Overlay.vue